import { MultiPartField, multiPartSchema } from './MultiPartField';
import type { FieldPart, FormFieldComponent } from './types-reexport';

const PARTS: readonly FieldPart[] = [
  { role: 'initialsFormField', fallbackName: 'initials' },
  { role: 'surnamePrepositionFormField', fallbackName: 'surnamePreposition' },
  { role: 'surnameFormField', fallbackName: 'surname' },];

const GenericFormNameField: FormFieldComponent = () => <MultiPartField parts={PARTS} />;

GenericFormNameField.formSchema = content => multiPartSchema(content, PARTS);

export default GenericFormNameField;
